<div class="post-progress">
  <p class="my-2" *ngIf="summary$ | async as summary">
    Posting {{ summary.total }} load(s):
    <span class="text-success ml-2">{{ summary.success }} succeeded</span>
    <span class="text-danger ml-2" *ngIf="summary.error > 0">{{ summary.error }} failed</span>
    <span class="text-muted ml-2" *ngIf="summary.pending + summary.inProgress > 0">
      {{ summary.pending + summary.inProgress }} remaining
    </span>
  </p>

  <p-table [value]="rows$ | async" autoLayout="true" styleClass="p-datatable-no-border post-progress-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 40px"></th>
        <th>Order Number</th>
        <th>Origin</th>
        <th>Destination</th>
        <th>Status</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td><i [class]="statusIcon(row.status)"></i></td>
        <td>{{ row.referenceLoadDisplay }}</td>
        <td>{{ row.origin }}</td>
        <td>{{ row.destination }}</td>
        <td>
          {{ statusLabel(row.status) }}
          <div *ngIf="row.status === 'error' && row.errorMessages?.length" class="text-danger small">
            <div *ngFor="let msg of row.errorMessages">{{ msg }}</div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="d-flex justify-content-end mt-3">
    <button
      pButton
      type="button"
      label="Close"
      [disabled]="!(allComplete$ | async)"
      (click)="finish()"
    ></button>
  </div>
</div>
